const invertedMessages = {
  'You can now configure user modification workflow to include identity verification workflow stage.':
    'external.idp.enabled.successTextIV',
  'Data Fetch Error': 'external.idp.dataError',
  'Identity Verification configuration Action failed, please try again later.':
    'external.idp.dataError.messageIV',
  'Identity Verification': 'external.idp.identityVerification',
  'Settings have been updated successfully.': 'external.idp.save.successText',
  'Configured Providers': 'external.idp.configuredProviders',
  'Available Providers': 'external.idp.availableProviders',
  Providers: 'external.idp.tab.providers',
  Settings: 'external.idp.tab.settings',
};

export default invertedMessages;
